import { create } from "zustand";

import { MediaType } from "@/types/common";

type AreaType = {
  shape: "circle" | "poly" | "rect";
  coords: number[];
  href?: string;
};

type State = {
  showPages: boolean;
  activePageIndex: number;
  activePageSrc: string;
  areas: AreaType[];
  cropActive: boolean;
  cropValue: null;
  activeShare: boolean;
  shareData: MediaType | null;
  cropPreviewUrl: string;
  uploadStatus: "idle" | "cropping" | "uploading";
  editionModalOpen: boolean;
  pdfDownloading: boolean;
  showClipsModal: boolean;
  pageType: "thumbview" | "pageview" | "fullview";
};

type Actions = {
  setShowPages: (showPages: boolean) => void;
  setActivePageIndex: (activePageIndex: number) => void;
  setActivePageSrc: (activePageSrc: string) => void;
  setAreas: (areas: AreaType[]) => void;
  setCropActive: (cropActive: boolean) => void;
  setCropValue: (cropValue: null) => void;
  setActiveShare: (activeShare: boolean) => void;
  setShareData: (shareData: MediaType | null) => void;
  setCropPreviewUrl: (cropPreviewUrl: string) => void;
  setUploadStatus: (uploadStatus: "idle" | "cropping" | "uploading") => void;
  setEditionModalOpen: (editionModalOpen: boolean) => void;
  setPdfDownloading: (pdfDownloading: boolean) => void;
  setShowClipsModal: (showClipsModal: boolean) => void;
  setPageType: (pageType: "fullview" | "thumbview" | "pageview") => void;
};

const useEpaperStore = create<State & Actions>(set => ({
  showPages: false,
  activePageIndex: 0,
  activePageSrc: "",
  areas: [],
  cropActive: false,
  cropValue: null,
  activeShare: false,
  shareData: null,
  cropPreviewUrl: "",
  uploadStatus: "idle",
  editionModalOpen: false,
  pdfDownloading: false,
  isZoomed: false,
  showClipsModal: false,
  pageType: "fullview",
  setShowPages: showPages => set({ showPages }),
  setActivePageIndex: activePageIndex => set({ activePageIndex }),
  setActivePageSrc: activePageSrc => set({ activePageSrc }),
  setAreas: areas => set({ areas }),
  setCropActive: cropActive => set({ cropActive }),
  setCropValue: cropValue => set({ cropValue }),
  setActiveShare: activeShare => set({ activeShare }),
  setShareData: shareData => set({ shareData }),
  setCropPreviewUrl: cropPreviewUrl => set({ cropPreviewUrl }),
  setUploadStatus: uploadStatus => set({ uploadStatus }),
  setEditionModalOpen: editionModalOpen => set({ editionModalOpen }),
  setPdfDownloading: pdfDownloading => set({ pdfDownloading }),
  setShowClipsModal: showClipsModal => set({ showClipsModal }),
  setPageType: pageType => set({ pageType }),
}));

export default useEpaperStore;
